import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import { DatePickerField } from "../../../core/inputs/input";
import { useRef } from "react";
import { getVehicleListAction } from "../../../../services/Store/Actions/manageVehicleAction";
import { getDriverList } from "../../../../services/Store/Actions/driverslistActions";
import {
  createTrip,
  editTripExpenseAction,
  getCityAndState,
  getDistance,
  getLRList,
  getSavedAddress,
  getTripsNew,
  getVehicleLastTripAction,
  updateTrip,
} from "../../../../services/Store/Actions/TripsAction";
import moment from "moment";
import {
  getCityAndStateAction,
  omcVehicleBalanceAction,
} from "../../../../services/Store/Actions/omcActions";
import Toast from "../../../subComponents/toast";
import AddDriverV2 from "../../../TripsMainV2/Components/AddDriverV2";
import AddVehicleV2 from "../../../TripsMainV2/Components/AddVehicleV2";
import AddAddress from "../../../LoadReceipt/Components/AddAddress";
import DelayReason from "../../../TripsMainV2/Components/DelayReason";
import { toastStatus } from "../../../../services/Store/Actions/appActions";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SelectVendorModal from "../../../Vendor/Components/Modal/SelectVendorModal";
import AddVendor from "../AddVendor";
import {
  addFleet,
  saveKarzaVehicle,
  updateKarzaVehicleAction,
} from "../../../../services/Store/Actions/fleetActions";
import {
  createVendorAction,
  getVendorDetailsAction,
} from "../../../../services/Store/Actions/beneficiaryAction";
import ConfirmationModal from "../../../subComponents/confirmModal";
import { getWalletBalAction } from "../../../../services/Store/Actions/LogipeCardActions";
import { ClipLoader } from "react-spinners";
import { getBranch } from "../../../../services/Store/Actions/UserManagementAction";

function CreateTripFromLR(props) {
  const {
    toggle,
    modal,
    setModal,
    selectedRow,
    setSelectedRow,
    setCreateInvoice,
    setCustomerIdInvoice,
    setPaymentDetailsModal,
    routeData,
    setTripData,
    setVehicleMilage,
    setDriverSalary,
    setRouteData,
    authUser,
    setTripExpense,
    setReload,
    reload,
    driverSalary,
    vehicleMilage
  } = props;
  const [openToast, setOpenToast] = useState(false);
  const [openToastFailure, setOpenToastFailure] = useState(false);
  const [openToastFailureText, setOpenToastFailureText] = useState(
    "Error in creating trips"
  );
  const [tripIdTemp, setTripIdTemp] = useState("");
  const [startDate, setStartDate] = useState("");
  const [vrn, setVrn] = useState("");
  const [fleetId, setFleetId] = useState("");
  const [driverName, setDriverName] = useState("");
  const [driverUserId, setDriverUserId] = useState("");
  const [endDate, setEndDate] = useState("");
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  
  const [selectVendorModal, setSelectVendorModal] = useState(false);
  const [vendorDetails, setVendorDetails] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [driver, setdriver] = useState(false);
  const [vehicle, setVehicle] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const [vendor, setVendor] = useState(false);
  const addDriver = () => setdriver(!driver);
  const addVehicle = () => setVehicle(!vehicle);
  const addAddress = () => setAddressModal(!addressModal);
  const addVendor = () => setVendor(!vendor);
  const dispatch = useDispatch();
  const [search, setSearch] = useState(
    selectedRow?.[0]?.Fleet?.regNumber || ""
  );
  const [searchVendor, setSearchVendor] = useState("");
  const [searchBranch, setSearchBranch] = useState("");
  const [search1, setSearch1] = useState("");
  const [search2, setSearch2] = useState("");
  const [search3, setSearch3] = useState("");
  const [tripNo, setTripNo] = useState("");
  const [searchDriver, setSearchDriver] = useState(
    selectedRow?.[0]?.User?.fullName || ""
  );
  const [vehicleTripDetail, setVehicleTripDetail] = useState({});
  const [sourcePincode, setSourcePincode] = useState("");
  const [vendorCheck, setVendorCheck] = useState("");
  const [destPincode, setDestPincode] = useState("");
  const [distanceCal, setDistanceCal] = useState(0);
  const [hasCard, setHasCard] = useState(0);
  const [display1, setDisplay1] = useState(false);
  const [display2, setDisplay2] = useState(false);
  const [display3, setDisplay3] = useState(false);
  const [addStop, setAddStop] = useState(false);
  const [newStop, setNewStop] = useState({});
  const [list, setList] = useState([]);
  const [showStops, setShowStops] = useState(false);
  const [openDelayReason, setDelayReason] = useState(false);
  const toggleReason = () => {
    setDelayReason(!openDelayReason);
  };
  const [loader, setLoader] = useState(false);
  const datepickerRefEnd = useRef();
  const datepickerRefStart = useRef();
  const [color1, setColor1] = useState(-1);
  const [color2, setColor2] = useState(-1);
  const { cityAndStateList } = useSelector((store) => store?.trip);
  const { savedAddresses } = useSelector((state) => state?.trip);
  const [confirm, setConfirm] = useState(false);

  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);

  const onHide = () => {
    setConfirm(false);
  };
  // const handleConfrimClose = () => {
  //   setConfirm(false);
  // };
  // const toggleConfirmModal = () => {
  //   setConfirm(!confirm);
  // };
  const allFleets = useSelector(
    (state) => state?.manageVehicle?.allFleets?.rows
  );
  const vehCount = useSelector(
    (state) => state?.manageVehicle?.allFleets?.count
  );
  let { tripsCount, tripsListNew } = useSelector((store) => store?.trip);
  // const fastVeh =
  //   vehCount > 0 ? allFleets?.find((ele) => ele?.Fastag !== null) : "value";
  const driverList = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.rows
  );
  const driverCount = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.count
  );

  const branchList = useSelector(
    (state) => state?.userManagement?.branchData.rows
  );
  const branchCount = useSelector(
    (state) => state?.userManagement?.branchData.count
  );
  useEffect(() => {
    console.log("jijijr", searchBranch);
    let timeout;
    if (searchBranch == "") {
      dispatch(
        getBranch({
          offset: "",
          search: searchBranch,
          minKyc: "",
          sortAs: "",
          sortBy: "",
          limit: 10,
        }, ()=>{})
      );
    } else {
      timeout = setTimeout(() => {
        dispatch(
          getBranch({
            offset: "",
            search: searchBranch,
            minKyc: "",
            sortAs: "",
            sortBy: "",
            limit: 10,
          }, (res) => {console.log(res?.data)})
        );
      }, 250);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [searchBranch]);
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  const handleClickDatepickerIcon1 = () => {
    const datepickerElement = datepickerRefStart.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  let stopCount = list?.length || 0;
  const closeBtn = (
    <button
      className="close"
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
        backgroundColor: "#FFF",
        borderColor: "#2E7C7B",
        display: "flex",
        justifyContent: "space-evenly",
      }}
      onClick={toggle}
      type="button"
    >
      <div className="x">X</div>
    </button>
  );
  // let endDate = selectedRow?.[0]?.startDate
  //   ? new Date(selectedRow?.[0]?.startDate)
  //   : new Date();
  // let newEndDate = routeData?.durationCal
  //   ? new Date(endDate.setHours(endDate.getHours() + parseFloat(routeData?.durationCal)))
  //   : "";
  // console.log(
  //   "newEndDatenewEndDate",
  //   routeData,newEndDate
  // );
  const toastObject = useSelector((state) => state?.app?.toastObject);

  const validationSchema = Yup.object().shape({
    // tripNo: Yup.string()
    //     .required("TripNo is required"),
    source: Yup.string().required("Source is required"),

    destination: Yup.string().required("Destination is required"),

    fleetId: Yup.string().required("Vehicle is required"),

    driverUserId: Yup.string().required("Driver is required"),

    startDate: Yup.string().required("StartDate is required"),
  });
  useEffect(() => {
    let stops = {};
    if (routeData?.stopList?.length > 0) {
      // let stopsArr = Object.values(stops);
      setList(routeData?.stopList || []);
      distCalulation(routeData?.stopList || [])
    } else {
      console.log("selectedRoselectedRoww", selectedRow);
        let sortedList = selectedRow?.sort((a, b) =>
          a?.lrNo?.localeCompare(b?.lrNo)
        );
        console.log("selectedRoselectedRoww", sortedList);
        for (let index = 0; index < sortedList?.length; index++) {
          if (sortedList?.[index]?.fromAddress?.cityName) {
            stops[sortedList?.[index]?.fromAddress?.cityName] =
              sortedList?.[index]?.fromAddress;
          }
          if (sortedList?.[index]?.toAddress?.cityName) {
            stops[sortedList?.[index]?.toAddress?.cityName] =
              sortedList?.[index]?.toAddress;
        }
      }
      let stopsArr = Object.values(stops);
      distCalulation(stopsArr || [])
      setList(stopsArr || []);
    }
  }, []);
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const distCalulation = (newData) => {
    console.log("nnenfneiw",newData)
    if(newData?.length > 1){
      let resp = 0;
      for (let index = 0; index < newData.length-1; index++) {
        const element1 = newData[index];
        const element2 = newData[index+1];
        dispatch(
          getDistance(
            {
              source: element1?.pincode,
              des: element2?.pincode,
            },
            (res) => {
              if (res?.status == 200) {
                resp = resp + res?.data?.data?.distanceCal
                setDistanceCal(resp);
                console.log("hwuoehuwehoriuh", resp + res?.data?.data?.distanceCal);
              }
            }
          )
        );
      }
      console.log("hwuoehsdfsuwehoriuh", resp);
    }
  }
  const handleDragEnd = ({ destination, source }) => {
    if (!destination) return;
    console.log("dfsalistliliststda", list);
    let newData = reorder(list, source.index, destination.index)
    distCalulation(newData)
    setList(reorder(list, source.index, destination.index));
  };
  const handleClose = () => {
    if (setRouteData) setRouteData(null);
    if (setSelectedRow) setSelectedRow(null);
    setVendorDetails("");
    setModal(!modal);
  };
  useEffect(() => {
    let timeout;
    if (search == "") {
      console.log("jijijr", search);
      dispatch(
        getVehicleListAction({
          offset: "",
          search: search,
          minKyc: "",
          sortAs: "",
          sortBy: "",
          limit: 10,
          vendorId: vendorCheck,
        })
      );
    } else {
      timeout = setTimeout(() => {
        dispatch(
          getVehicleListAction({
            offset: "",
            search: search,
            minKyc: "",
            sortAs: "",
            sortBy: "",
            limit: 10,
            vendorId: vendorCheck,
          })
        );
      }, 250);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [search, vendorCheck]);

  useEffect(() => {
    dispatch(
      getTripsNew({
        offset: 0,
        limit: 10,
      })
    );
  }, []);
  // useEffect(() => {
  //   if(sourcePincode && destPincode){
  //     dispatch(
  //       getDistance({
  //         source: sourcePincode,
  //         des: destPincode,
  //       },(res) => {
  //         if(res?.status == 200){
  //           console.log("ppssspppppppp",res?.data?.data?.distanceCal)
  //           setDistanceCal(res?.data?.data?.distanceCal)
  //         }
  //       }))
  //   }
  // }, [sourcePincode,destPincode]);
  useEffect(() => {
    tripNumberFromLastTrip();
  }, [tripsListNew]);
  useEffect(() => {
    console.log("jijijr", search);
    let timeout;
    if (searchDriver == "") {
      dispatch(
        getDriverList({
          offset: "",
          search: searchDriver,
          minKyc: "",
          sortAs: "",
          sortBy: "",
          limit: 10,
        })
      );
    } else {
      timeout = setTimeout(() => {
        dispatch(
          getDriverList({
            offset: "",
            search: searchDriver,
            minKyc: "",
            sortAs: "",
            sortBy: "",
            limit: 10,
          })
        );
      }, 250);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [searchDriver]);
  useEffect(() => {
    if (display1 == true) {
      // dispatch(findTripAddressV2({},(res)=>{
      //   console.log("findTripAddressV2",res);
      // }))
      let timeout;
      if (search1 == "") {
        dispatch(
          getSavedAddress({ address: search1 }, (res) => {
            console.log("getSavedAddress", res);
          })
        );
      } else {
        timeout = setTimeout(() => {
          dispatch(
            getSavedAddress({ address: search1 }, (res) => {
              console.log("getSavedAddress", res);
            })
          );
        }, 250);
      }
      if(timeout) return () => {
        clearTimeout(timeout);
      };
    }
  }, [display1, search1]);
  useEffect(() => {
    if (display2 == true) {
      let timeout;
      if (search2 == "") {
        dispatch(
          getSavedAddress({ address: search2 }, (res) => {
            console.log("getSavedAddress", res);
          })
        );
      } else {
        timeout = setTimeout(() => {
          dispatch(
            getSavedAddress({ address: search2 }, (res) => {
              console.log("getSavedAddress", res);
            })
          );
        }, 250);
      }
      if(timeout) return () => {
        clearTimeout(timeout);
      };
    }
  }, [display2, search2]);
  useEffect(() => {
    console.log("getSavedAddressnjnken");
    if (display3 == true) {
      dispatch(
        getSavedAddress({ address: search3 }, (res) => {
          console.log("getSavedAddress", res);
        })
      );
    }
  }, [display3, search3]);

  function tripNumberFromLastTrip() {
    let tripNoString = tripsListNew?.[0]?.tripNo;
    let { number, remainingString } = findNumberAtEnd(tripNoString || "");
    let finalString;
    if (number == null) {
      finalString = 1;
    } else {
      finalString = parseInt(number) + 1;
    }

    console.log("tripNumberFromLastTrip", finalString);
    setTripNo(remainingString + finalString);
    console.log(
      "tripNumberFromLastTrip 2222",
      remainingString + finalString,
      number,
      remainingString
    );
  }
  function findNumberAtEnd(str) {
    const match = str.match(/\d+$/);
    if (match) {
      // Find the position where the number starts
      const numberStartIndex = match.index;
      // Split the string into the part before the number and the number itself
      const remainingString = str.substring(0, numberStartIndex);
      const number = parseInt(match[0], 10);
      return {
        remainingString: remainingString,
        number: number,
      };
    } else {
      // If no number is found at the end, return the original string and null for the number
      return {
        remainingString: str,
        number: null,
      };
    }
  }
  useEffect(() => {
    console.log("kkkkjjjjjjfhhf", selectedRow);
    if (selectedRow?.[0]?.fleetId) {
      dispatch(
        getVehicleLastTripAction(
          { fleetId: selectedRow?.[0]?.fleetId },
          (res) => {
            if (res.status == 200) {
              console.log("getVehicleLastTripAction", res?.data?.data);
              setVehicleTripDetail(res?.data?.data);
            }
          }
        )
      );
    }
    if (selectedRow?.[0]?.Fleet?.vendorId) {
      setVendorId(selectedRow?.[0]?.Fleet?.vendorId)
      dispatch(
        getVendorDetailsAction(
          { id: selectedRow?.[0]?.Fleet?.vendorId },
          (resp) => {
            if (resp?.status == 200) {
              console.log("knsnifn", resp);
              setVendorDetails(resp?.data?.data?.name);
            }
          }
        )
      );
    }
    // if(selectedRow?.[0]?.Fleet?.regNumber){
    //   setSearch(selectedRow?.[0]?.Fleet?.regNumber)
    // }
    // if(selectedRow?.[0]?.User?.fullName){
    //   setSearchDriver(selectedRow?.[0]?.User?.fullName)
    // }
  }, [selectedRow?.[0]?.fleetId]);

  useEffect(() => {
    // console.log("mkmninerionf",new Date(selectedRow?.[0]?.startDate))
    setVehicleMilage(selectedRow?.[0]?.Fleet?.mileage)
    setDriverSalary(selectedRow?.[0]?.Fleet?.driverSalary)
    setVrn(selectedRow?.[0]?.Fleet?.regNumber);
    setFleetId(selectedRow?.[0]?.fleetId);
    setDriverName(selectedRow?.[0]?.User?.fullName);
    setDriverUserId(selectedRow?.[0]?.userId);
    setStartDate(
      selectedRow?.[0]?.startDate
        ? new Date(selectedRow?.[0]?.startDate)
        : new Date()
    );
    setEndDate(
      routeData?.durationCal
        ? new Date(
            (selectedRow?.[0]?.startDate
              ? new Date(selectedRow?.[0]?.startDate)
              : new Date()
            ).setHours(
              (selectedRow?.[0]?.startDate
                ? new Date(selectedRow?.[0]?.startDate)
                : new Date()
              ).getHours() +
                parseFloat(routeData?.durationCal) / 60
            )
          )
        : ""
    );
    // if (
    //   routeData?.fromAddressRoute?.addressId &&
    //   routeData?.toAddressRoute?.addressId
    // ) {
    //   setSourcePincode(routeData?.fromAddressRoute?.pincode);
    //   setDestPincode(routeData?.toAddressRoute?.pincode);
    //   dispatch(
    //     getDistance(
    //       {
    //         source: routeData?.fromAddressRoute?.pincode,
    //         des: routeData?.toAddressRoute?.pincode,
    //       },
    //       (res) => {
    //         if (res?.status == 200) {
    //           console.log("ppssspppppppp", res?.data?.data?.distanceCal);
    //           setDistanceCal(res?.data?.data?.distanceCal);
    //         }
    //       }
    //     )
    //   );
    // } else if (
    //   selectedRow?.[0]?.toAddress?.addressId &&
    //   selectedRow?.[0]?.fromAddress?.addressId
    // ) {
    //   setSourcePincode(selectedRow?.[0]?.fromAddress?.pincode);
    //   setDestPincode(selectedRow?.[0]?.toAddress?.pincode);
    //   dispatch(
    //     getDistance(
    //       {
    //         source: selectedRow?.[0]?.toAddress?.pincode,
    //         des: selectedRow?.[0]?.fromAddress?.pincode,
    //       },
    //       (res) => {
    //         if (res?.status == 200) {
    //           console.log("ppssspppppppp", res?.data?.data?.distanceCal);
    //           setDistanceCal(res?.data?.data?.distanceCal);
    //         }
    //       }
    //     )
    //   );
    // }
  }, []);

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
        // scrollable={true}
        centered={true}
      >
        <ModalBody
          className="transactionModalBody"
          style={{ marginTop: "25px" }}
        >
          <div className="PGCollectionBox">
            <div className=/*"PGCollectionclose */ "closeEffectRow close-btn-for-transaction">
              <div className="closeEffect" onClick={handleClose}>
                <SvgImage
                  classname="close-btn-text"
                  style={{ width: "10%", height: "10%" }}
                  name="CloseButtonLogo"
                  width="20%"
                  height="20%"
                />
              </div>
            </div>
            <div
              className="PGCollectiontText col-9"
              style={{ marginLeft: "50px" }}
            >
              Create Trip
            </div>
            <Formik
              // isValid='true'
              enableReinitialize
              // validationSchema={validationSchema}
              initialValues={{
                source:
                  stopCount > 0
                    ? `${list?.[0]?.address}, ${list?.[0]?.cityName} - ${list?.[0]?.stateName}`
                    : routeData?.fromAddressRoute?.addressId
                    ? `${routeData?.fromAddressRoute?.address}, ${routeData?.fromAddressRoute?.cityName} - ${routeData?.fromAddressRoute?.stateName}`
                    : selectedRow?.[0]?.fromAddress?.addressId
                    ? `${selectedRow?.[0]?.fromAddress?.address}, ${selectedRow?.[0]?.fromAddress?.cityName} - ${selectedRow?.[0]?.fromAddress?.stateName}` ||
                      ""
                    : "",
                destination:
                  stopCount > 1
                    ? `${list?.[stopCount - 1]?.address}, ${
                        list?.[stopCount - 1]?.cityName
                      } - ${list?.[stopCount - 1]?.stateName}`
                    : routeData?.toAddressRoute?.addressId
                    ? `${routeData?.toAddressRoute?.address}, ${routeData?.toAddressRoute?.cityName} - ${routeData?.toAddressRoute?.stateName}`
                    : selectedRow?.[0]?.toAddress?.addressId
                    ? `${selectedRow?.[0]?.toAddress?.address}, ${selectedRow?.[0]?.toAddress?.cityName} - ${selectedRow?.[0]?.toAddress?.stateName}` ||
                      ""
                    : "",
                startDate: startDate,
                endDate: endDate,
                tripNo: tripNo || "TR-1",
                vrn: vrn || "",
                driver: driverName || "",
                fleetId: fleetId || "",
                sourceId:
                  stopCount > 0
                    ? list?.[0]?.addressId
                    : routeData?.fromAddressRoute?.addressId
                    ? routeData?.fromAddressRoute?.addressId
                    : selectedRow?.[0]?.fromAddress?.addressId || "",
                destId:
                  stopCount > 1
                    ? list?.[stopCount - 1]?.addressId
                    : routeData?.toAddressRoute?.addressId
                    ? routeData?.toAddressRoute?.addressId
                    : selectedRow?.[0]?.toAddress?.addressId || "",
                driverUserId: driverUserId || "",
                vehicleMilage: vehicleMilage || "",
                driverSalary: driverSalary || "",
                vendorId: vendorId || "",
                omc: "",
                expectedDistanceKM: routeData?.distanceCal
                  ? parseFloat(routeData?.distanceCal)?.toFixed(2)
                  : routeData?.expectedDistanceKM
                  ? parseFloat(routeData?.expectedDistanceKM)?.toFixed(2)
                  : parseFloat(distanceCal || 0)?.toFixed(2),
                isDummy: "1",
                vendor: vendorDetails || "",
                newAdderss: newStop.address
                ? newStop.address +
                    ", " +
                    newStop.cityName +
                    " - " +
                    newStop.stateName || ""
                : "",
              }}
              onSubmit={(values) => {
                //create new trip
                let objVal = {
                  source: String(values?.sourceId),
                  destination: String(values?.destId),
                  fleetId: values?.fleetId,
                  userId: values?.driverUserId,
                  expectedStartTime: values.startDate,
                  tripNo: values?.tripNo ? values?.tripNo : "",
                  selectedLr: selectedRow,
                  expectedDistanceKM: values.expectedDistanceKM,
                  stopList: list,
                  branchId: values?.branchId
                };

                console.log("dfsalistliliststda", objVal);
                if (values?.endDate != "") {
                  objVal["expectedEndTime"] = values.endDate;
                }
                if (values?.vendorId) {
                  objVal["vendorId"] = values.vendorId;
                }
                // if (setVehicleMilage) setVehicleMilage(values.vehicleMilage);
                // console.log("values.driverSalary", values.driverSalary);
                // if (setDriverSalary)
                  // setDriverSalary(
                  //   values.driverSalary || routeData?.driverExpected
                  // );
                // setOpenToast(true);
                // handleClose(false);
                const toggleModalToast = (toastObject) => {
                  console.log("NEW FLOW TOAST", toastObject);
                  if (toastObject?.status) {
                    setPaymentDetailsModal(true);
                    handleClose(false);
                    // setTripData({});
                    setSelectedRow([]);
                    setOpenToast(false);
                    if (setReload) setReload(!reload);
                  }
                  dispatch(
                    toastStatus({
                      toastStatus: false,
                    })
                  );
                };
                const handleCloseToast = (toastObject) => {
                  console.log("NEW FLOW TOAST", toastObject);
                  if (toastObject?.status) {
                    setPaymentDetailsModal(true);
                    handleClose(false);
                    // setTripData({});
                    setSelectedRow([]);
                    setOpenToast(false);
                    if (setReload) setReload(!reload);
                  }
                  dispatch(
                    toastStatus({
                      toastStatus: false,
                    })
                  );
                };
                let xxx = [];
                let isCard = 0;
                let isOmc = 0;
                let data = {
                  // tripId: tripData?.tripId,
                };
                driverList?.map((item, i) => {
                  if (item?.User?.userId == values?.driverUserId)
                    isCard = item?.WalletAccount?.neoKred?.accountStatus;
                });
                allFleets?.map((item, i) => {
                  if (item?.fleetId == values?.fleetId) isOmc = item?.Omc;
                });
                if (isCard != 4 && hasCard != 4) {
                  if (values?.driverSalary || routeData?.driverExpected) {
                    xxx.push({
                      header: "Cash",
                      type: "Salary",
                      expacted:
                        parseInt(values?.driverSalary) *
                          (parseInt(values.expectedDistanceKM) || 0) || "0",
                      advance: "0",
                      totalExpense: "0",
                      autoAdvance: false,
                      autoFinal: false,
                      advanceStatus: false,
                      payable:
                        parseInt(values?.driverSalary) *
                          (parseInt(values.expectedDistanceKM) || 0) || "0",
                    });
                  }
                } else {
                  data["driverTotal"] =
                    parseInt(values?.driverSalary) *
                      (parseInt(values.expectedDistanceKM) || 0) ||
                    routeData?.driverExpected ||
                    "0";
                  if (
                    routeData?.driverAdvance &&
                    routeData?.driverAdvance != "0"
                  )
                    data["driverAdvance"] = routeData?.driverAdvance;
                }

                if (
                  (routeData?.ownerExpected || routeData?.ownerAdvance) &&
                  values?.vendorId
                ) {
                  data["vendorAdvance"] = routeData?.ownerExpected || "0";
                  data["vendorTotal"] = routeData?.ownerAdvance || "0";
                }
                if (
                  routeData?.fuelExpected ||
                  values?.vehicleMilage ||
                  routeData?.fuelAdvance
                ) {
                  let expactedExpance =
                    (parseInt(values.expectedDistanceKM) || 0) /
                      parseInt(values?.vehicleMilage) || 0;
                  if (values?.omc || isOmc) {
                    if (routeData?.fuelAdvance)
                      data["fuelAdvance"] = routeData?.fuelAdvance || "0";
                    if (expactedExpance || routeData?.fuelExpected)
                      data["fuelTotal"] =
                        expactedExpance || routeData?.fuelExpected || "0";
                  } else {
                    xxx.push({
                      header: "Cash",
                      type: "Fuel",
                      expacted:
                        expactedExpance || routeData?.fuelExpected || "0",
                      advance: routeData?.fuelAdvance || "0",
                      totalExpense: "0",
                      autoAdvance: false,
                      autoFinal: false,
                      advanceStatus: false,
                      payable:
                        expactedExpance || routeData?.fuelExpected || "0",
                    });
                  }
                }
                if (routeData?.fastagExpected || routeData?.fastagFinal) {
                  data["fastagTotal"] = routeData?.fastagFinal || "0";
                  data["fastagAdvance"] = routeData?.fastagExpected || "0";
                }
                data["cashData"] = xxx;
                let x = 0;
                let p = xxx?.map((item) => {
                  if (item?.header == "Cash") {
                    x = parseFloat(x) + parseFloat(item?.expacted || 0);
                    return x;
                  }
                });
                if (x != "0") {
                  data["cashData"] = xxx;
                  data["cashTotal"] = x;
                }

                // console.log("nknirnfinreinnerjfnier",data,allFleets,driverList,isCard,values?.fleetId,
                // isOmc)
                setLoader(true);
                dispatch(
                  createTrip(
                    objVal,
                    toggleModalToast,
                    handleCloseToast,
                    (res) => {
                      console.log("knkodnfignreipjnpiernp", res);
                      if (res?.status == 200) {
                        // alert("success");
                        data["tripId"] = res?.data?.data?.tripId;
                        dispatch(
                          editTripExpenseAction(
                            data,
                            (resp) => {
                              console.log(
                                "editTripExpenseAction",
                                resp,
                                toastObject
                              );
                              setLoader(false);
                              if (resp.status == 200) {
                                setOpenToast(true);
                                // handleClose(false);
                                if (setTripExpense) {
                                  setTripExpense(resp?.data?.data);
                                }
                                if (values?.driverUserId)
                                  dispatch(
                                    getWalletBalAction(values?.driverUserId)
                                  );
                                dispatch(
                                  omcVehicleBalanceAction(values?.fleetId)
                                );
                                if (values?.vendorId)
                                  dispatch(
                                    getVendorDetailsAction(
                                      { id: values?.vendorId },
                                      (resp) => {}
                                    )
                                  );
                                setTripData(res?.data?.data);
                                setTripIdTemp(res?.data?.data?.tripId);
                                // setFreight(!freight);
                                console.log("...............", resp);
                              }
                            },
                            null,
                            null,
                            "1"
                          )
                        );
                      } else {
                        console.log("kkjjjdjsjsijdi", res);
                        setLoader(false);
                        // setOpenToastFailure(true);
                        // setOpenToastFailureText(res?.data?.message);
                      }
                    }
                  )
                );
              }}
            >
              {({
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                isValid,
                errors,
                setFieldTouched,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  style={{ marginTop: "50px", padding: "0 75px 0 50px" }}
                >
                  {console.log("knjijhihe", values)}
                  <FormGroup>
                    <label for="tripNo" className="heading3 semiBold">
                      Trip Number :
                    </label>
                    <input
                      type="text"
                      id="tripNo"
                      className={`inputBoxCust1 form-control-1 ${
                        touched.amount && errors.amount ? "is-invalid" : ""
                      }`}
                      name="tripNo"
                      onChange={(event) => {
                        // setSearch(event.target.value);
                        setFieldValue("tripNo", event.target.value, true);
                      }}
                      value={values.tripNo}
                      touched={touched.tripNo}
                      errors={errors.tripNo}
                      placeholder="TR-12345"
                    />
                  </FormGroup>
                  <FormGroup
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "30px",
                    }}
                  >
                    <FormGroup>
                      <label for="vrn" className="heading3 semiBold">
                        Vehicle No:
                      </label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                      >
                        <input
                          className={`inputBoxCust1 form-control-1 ${
                            touched.vrn && errors.vrn ? "is-invalid" : ""
                          }`}
                          readOnly={
                            selectedRow?.[0]?.Fleet?.regNumber ? true : false
                          }
                          type="text"
                          id="vrn"
                          name="vrn"
                          touched={touched.vrn}
                          errors={errors.vrn}
                          onClick={() => {
                            setOpen(true);
                          }}
                          onBlur={() => {
                            setOpen(false);
                          }}
                          onChange={(event) => {
                            console.log("kjjsijdis", values?.vrn);
                            if (event.target.value == "" && !vendorCheck) {
                              setVendorDetails('');
                              setFieldValue("vendor", "", true);
                              setFleetId("");
                              setFieldValue("fleetId", "", true);
                              setVendorId("");
                              setFieldValue("vendorId", "", true);
                              setFieldValue("isDummy", "1", true);
                            }
                            setFieldValue("vrn", event.target.value, true);
                            setSearch(event.target.value);
                          }}
                          value={values.vrn}
                          autoComplete="off"
                          onFocus={(e) => {
                            setOpen(true);
                          }}
                          placeholder="Select Vehicle"
                        />
                        {/* {console.log("kkkkllll", values.vrn)} */}
                        {/* {values.vrn ? null : ( */}
                        {/* <span
                          style={{ marginLeft: "20px", cursor: "pointer" }}
                          onClick={addVehicle}
                          className={`inputBoxCust2`}
                        >
                          +
                        </span> */}
                        {/* )} */}
                      </div>
                      <div style={{ position: "relative" }}>
                        {open ? (
                          <div className="driverSearchContainer containerShadow">
                            <div
                              style={{
                                position: "absolute",
                                top: "0.3rem",
                                right: "0.3rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setOpen(false);
                              }}
                            >
                              <SvgImage name="CloseButtonLogo" />
                            </div>
                            {allFleets?.map((item, i) => {
                              return (
                                <>
                                  {/* {item?.Fastag !== null ? ( */}
                                  <div
                                    key={i}
                                    className="flexStyling padding8 "
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={(event) => {
                                      setOpen(false);
                                      console.log(
                                        "kkkkllll",
                                        item,
                                        item?.regNumber
                                      );
                                      setFieldValue(
                                        "vrn",
                                        item?.regNumber,
                                        true
                                      );
                                      setVrn(item?.regNumber);
                                      // setFieldValue(
                                      //   "vrn",
                                      //   item?.regNumber,
                                      // );
                                      // setTimeout(() =>
                                      //   setFieldTouched("vrn", true)
                                      // );
                                      setFleetId(item?.fleetId);
                                      setFieldValue(
                                        "fleetId",
                                        item?.fleetId,
                                        true
                                      );
                                      setVehicleMilage(item?.mileage)
                                      setFieldValue(
                                        "vehicleMilage",
                                        item?.mileage,
                                        true
                                      );
                                      setDriverSalary(item?.driverSalary)
                                      setFieldValue(
                                        "driverSalary",
                                        item?.driverSalary,
                                        true
                                      );
                                      if (item?.vendorId) {
                                        setVendorId(item?.vendorId)
                                        setFieldValue(
                                          "vendorId",
                                          item?.vendorId,
                                          true
                                        );
                                        dispatch(
                                          getVendorDetailsAction(
                                            { id: item?.vendorId },
                                            (resp) => {
                                              if (resp?.status == 200) {
                                                console.log("knsnifn", resp);
                                                setVendorDetails(resp?.data?.data?.name);
                                                setFieldValue(
                                                  "vendor",
                                                  resp?.data?.data?.name,
                                                  true
                                                );
                                              }
                                            }
                                          )
                                        );
                                        if (item?.isRegular == 3)
                                          setFieldValue("isDummy", 3, true);
                                        else
                                          setFieldValue("isDummy", "2", true);
                                        // setFieldValue("isDummy", 1, true);
                                      } else {
                                        setVendorDetails('');
                                        setFieldValue("vendor", "", false);
                                        setVendorId("")
                                        setFieldValue("vendorId", "", false);
                                        setFieldValue("isDummy", "1", true);
                                      }

                                      if (item?.Omc?.rcNumber) {
                                        setFieldValue("omc", 1, true);
                                      }
                                      if (
                                        item?.FleetDriverMapHistories?.length >
                                        0
                                      ) {
                                        setSearchDriver(
                                          item?.FleetDriverMapHistories[0]
                                            ?.Driver?.User?.fullName
                                        );
                                        setDriverName(
                                          item?.FleetDriverMapHistories
                                            ?.length > 0
                                            ? item?.FleetDriverMapHistories[0]
                                                ?.Driver?.User?.fullName
                                            : ""
                                        );
                                        setFieldValue(
                                          "driver",
                                          item?.FleetDriverMapHistories
                                            ?.length > 0
                                            ? item?.FleetDriverMapHistories[0]
                                                ?.Driver?.User?.fullName
                                            : "",
                                          true
                                        );
                                        setDriverUserId(
                                          item?.FleetDriverMapHistories
                                            ?.length > 0
                                            ? item?.FleetDriverMapHistories[0]
                                                ?.Driver?.userId
                                            : ""
                                        );
                                        setFieldValue(
                                          "driverUserId",
                                          item?.FleetDriverMapHistories
                                            ?.length > 0
                                            ? item?.FleetDriverMapHistories[0]
                                                ?.Driver?.userId
                                            : "",
                                          true
                                        );
                                      }
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name="vrn"
                                      value={item?.fleetId}
                                      id={item?.fleetId}
                                    />
                                    <div
                                      className="padding16L"
                                      value={item?.fleetId}
                                    >
                                      {item?.regNumber}
                                    </div>
                                  </div>
                                  {/* ) : (
                                    <></>
                                  )} */}
                                </>
                              );
                            })}
                            {vehCount == 0 ? (
                              <div
                                className="row"
                                style={{ margin: 0 }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                <div
                                  className="heading3 semiBold padding16 padding24B col-12"
                                  style={{
                                    padding: "20px",
                                    textAlign: "center",
                                  }}
                                >
                                  No Vehicle Available
                                </div>
                                <div
                                  className="col-12"
                                  style={{ padding: 0, textAlign: "center" }}
                                >
                                  <Button
                                    className="greenButtonNew FontNS14"
                                    disabled={
                                      values?.vrn?.length < 4 ? true : false
                                    }
                                    style={{ textAlign: "left" }}
                                    onClick={() => {
                                      const toggleModalToast = () => {
                                        dispatch(
                                          toastStatus({
                                            toastStatus: false,
                                          })
                                        );
                                      };
                                      const handleCloseToast = () => {
                                        dispatch(
                                          toastStatus({
                                            toastStatus: false,
                                          })
                                        );
                                      };
                                      setLoader2(true);
                                      dispatch(
                                        addFleet(
                                          {
                                            vehicleNumber: values?.vrn,
                                            isRegular: 0,
                                          },
                                          (response) => {
                                            // actions.setSubmitting(false);
                                            console.log(
                                              "respppppppppp11211",
                                              response
                                            );
                                            setLoader2(false);
                                            if (response?.type === "success") {
                                              setFleetId(
                                                response?.data?.dataValues
                                                  ?.fleetId ||
                                                  response?.data?.fleetId
                                              );
                                              setFieldValue(
                                                "fleetId",
                                                response?.data?.dataValues
                                                  ?.fleetId ||
                                                  response?.data?.fleetId,
                                                true
                                              );
                                              setVrn(
                                                response?.data?.dataValues
                                                  ?.regNumber ||
                                                  response?.data?.regNumber
                                              );
                                              setFieldValue(
                                                "vrn",
                                                response?.data?.dataValues
                                                  ?.regNumber ||
                                                  response?.data?.regNumber,
                                                true
                                              );
                                              setFieldValue(
                                                "isDummy",
                                                "0",
                                                true
                                              );
                                            }
                                          },
                                          toggleModalToast,
                                          handleCloseToast
                                        )
                                      );
                                    }}
                                  >
                                    {loader2 ? (
                                      <>
                                        <ClipLoader
                                          // color={"#fff"}
                                          loading={true}
                                          size={20}
                                          aria-label="Loading Spinner"
                                          data-testid="loader"
                                        />
                                      </>
                                    ) : (
                                      "Add Vendor Vehicle"
                                    )}
                                  </Button>
                                </div>
                                <div
                                  className="col-12"
                                  style={{ padding: 0, textAlign: "center" }}
                                >
                                  <Button
                                    className="greenButtonNew FontNS14"
                                    disabled={
                                      values?.vrn?.length < 8 ? true : false
                                    }
                                    onClick={() => {
                                      const toggleModalToast = () => {
                                        dispatch(
                                          toastStatus({
                                            toastStatus: false,
                                          })
                                        );
                                      };
                                      const handleCloseToast = () => {
                                        dispatch(
                                          toastStatus({
                                            toastStatus: false,
                                          })
                                        );
                                      };
                                      setLoader3(true);
                                      dispatch(
                                        saveKarzaVehicle(
                                          {
                                            vrn: values?.vrn,
                                          },
                                          (res) => {
                                            if (
                                              res?.data?.chassisNumber != "" &&
                                              res?.data?.chassisNumber != null
                                            ) {
                                              dispatch(
                                                addFleet(
                                                  {
                                                    vehicleNumber: values?.vrn,
                                                  },
                                                  (response) => {
                                                    console.log(
                                                      "resppppppp8888ppp",
                                                      response,
                                                      response?.type,
                                                      response?.type ==
                                                        "success",
                                                      response?.type ===
                                                        "success"
                                                    );
                                                    setLoader3(false);
                                                    if (
                                                      response?.type ===
                                                        "success" &&
                                                      response?.data
                                                    ) {
                                                      dispatch(
                                                        updateKarzaVehicleAction(
                                                          {
                                                            fleetId:
                                                              response?.data
                                                                ?.dataValues
                                                                ?.fleetId,
                                                            vrn: response?.data
                                                              ?.dataValues
                                                              ?.regNumber,
                                                          },
                                                          (res) => {
                                                            setFleetId(
                                                              response?.data
                                                                ?.dataValues
                                                                ?.fleetId
                                                            );
                                                            setFieldValue(
                                                              "fleetId",
                                                              response?.data
                                                                ?.dataValues
                                                                ?.fleetId,
                                                              true
                                                            );
                                                            setVrn(
                                                              response?.data
                                                                ?.dataValues
                                                                ?.regNumber
                                                            );
                                                            setFieldValue(
                                                              "vrn",
                                                              response?.data
                                                                ?.dataValues
                                                                ?.regNumber,
                                                              true
                                                            );
                                                          }
                                                        )
                                                      );
                                                      //window.location.reload();
                                                    } else {
                                                      //alert(response);
                                                    }
                                                  },
                                                  toggleModalToast,
                                                  handleCloseToast
                                                )
                                              );
                                            } else {
                                              setLoader3(false);
                                              dispatch(
                                                toastStatus({
                                                  toastStatus: true,
                                                  message: `Please Enter Correct Vehicle`,
                                                  status: false,
                                                })
                                              );
                                            }
                                          }
                                        )
                                      );
                                    }}
                                  >
                                    {loader3 ? (
                                      <>
                                        <ClipLoader
                                          // color={"#fff"}
                                          loading={true}
                                          size={20}
                                          aria-label="Loading Spinner"
                                          data-testid="loader"
                                        />
                                      </>
                                    ) : (
                                      "Add Vehicle"
                                    )}
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              // :
                              //  fastVeh == undefined ? (
                              //   <div className="heading3 semiBold padding16 padding24B">
                              //     No Vehicle Available
                              //   </div>
                              // )
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}

                        <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                          {errors.fleetId && touched.fleetId ? (
                            <div>*{errors.fleetId}</div>
                          ) : null}
                        </div>
                      </div>
                    </FormGroup>
                    {values?.isDummy == "0" || values?.isDummy == "2" ? (
                      <FormGroup>
                        <label for="vrn" className="heading3 semiBold">
                          Vendor :
                        </label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <input
                            className={`inputBoxCust1 form-control-1 ${
                              touched.vendor && errors.vendor
                                ? "is-invalid"
                                : ""
                            }`}
                            type="text"
                            id="vendor"
                            name="vendor"
                            touched={touched.vendor}
                            errors={errors.vendor}
                            // onBlur={() => {
                            //   handleBlur("vendorId");
                            //   setSelectVendorModal(false);
                            // }}
                            onClick={() => {
                              setSelectVendorModal(true);
                            }}
                            disabled={
                              values?.isDummy == "2" || values?.isDummy == "3"
                                ? true
                                : false
                            }
                            autoComplete="off"
                            onChange={(event) => {
                              console.log("kkjjsss", event.target.value);
                              if (event.target.value == "") {
                                setVendorDetails("")
                                setFieldValue("vendor", "", false);
                                // setFieldValue("isDummy", "", true);
                                setVendorId("")
                                setFieldValue("vendorId", "", false);
                                setVendorCheck("");
                              } else setSelectVendorModal(true);
                            }}
                            value={values.vendor}
                            // onFocus={(e) => {
                            //   setSelectVendorModal(true);
                            // }}
                            placeholder="Select Vendor"
                          />
                          {values?.isDummy == "2" || values?.isDummy == "3" ? (
                            <></>
                          ) : (
                            <span
                              style={{ marginLeft: "20px", cursor: "pointer" }}
                              onClick={addVendor}
                              className={`inputBoxCust2`}
                            >
                              +
                            </span>
                          )}
                        </div>
                        <div style={{ position: "relative" }}>
                          <div
                            style={{ margin: "7px 0 0px 96px", color: "red" }}
                          >
                            {errors.vendor && touched.vendor ? (
                              <div>*{errors.vendor}</div>
                            ) : null}
                          </div>
                        </div>
                      </FormGroup>
                    ) : (
                      <FormGroup>
                        <label for="vrn" className="heading3 semiBold">
                          Driver:
                        </label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <input
                            className={`inputBoxCust1 form-control-1 ${
                              touched.amount && errors.amount
                                ? "is-invalid"
                                : ""
                            }`}
                            type="text"
                            id="driver"
                            name="driver"
                            touched={touched.driver}
                            errors={errors.driver}
                            onBlur={() => {
                              handleBlur("driver");
                              setOpen1(false);
                            }}
                            onClick={() => {
                              setOpen1(true);
                            }}
                            autoComplete="off"
                            onChange={(event) => {
                              console.log("kkjjsss", event.target.value);
                              setOpen1(true);
                              setSearchDriver(event.target.value);
                              setFieldValue("driver", event.target.value, true);
                            }}
                            value={values.driver}
                            onFocus={(e) => {
                              setOpen1(true);
                            }}
                            placeholder="Select Driver"
                            disabled={
                              values?.isDummy == 2 || values?.isDummy == "0"
                                ? true
                                : false
                            }
                          />
                          {console.log(
                            "values.drivervalues.driver",
                            values.driver
                          )}
                          <span
                            id="addDriver"
                            style={{ marginLeft: "20px", cursor: "pointer" }}
                            onClick={addDriver}
                            className={`inputBoxCust2`}
                          >
                            +
                          </span>
                        </div>
                        <div style={{ position: "relative" }}>
                          {open1 ? (
                            <div className="driverSearchContainer containerShadow">
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0.3rem",
                                  right: "0.3rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setOpen1(false);
                                }}
                              >
                                <SvgImage name="CloseButtonLogo" />
                              </div>
                              {driverList?.map((item, i) => {
                                return (
                                  <>
                                    {item?.Fastag !== null ? (
                                      <div
                                        key={i}
                                        className="flexStyling padding8 "
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={(event) => {
                                          setDriverName(item?.User?.fullName)
                                          setDriverUserId(item?.User?.userId)
                                          setFieldValue(
                                            "driver",
                                            item?.User?.fullName,
                                            true
                                          );
                                          setFieldValue(
                                            "driverUserId",
                                            item?.User?.userId,
                                            true
                                          );
                                          console.log(
                                            "itemadas",
                                            item?.WalletAccount?.neoKred
                                              ?.accountStatus
                                          );
                                          setHasCard(
                                            item?.WalletAccount?.neoKred
                                              ?.accountStatus
                                          );
                                          setOpen1(false);
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="driver"
                                          value={item?.User?.userId}
                                          id={item?.User?.userId}
                                        />
                                        <div className="padding16L">
                                          {item?.User?.fullName.length > 35
                                            ? item?.User?.fullName.split(
                                                0,
                                                35
                                              ) + "..."
                                            : item?.User?.fullName}
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                );
                              })}
                              {driverCount == 0 ? (
                                <div className="heading3 semiBold padding16 padding24B">
                                  No driver Available
                                </div>
                              ) : driverCount == undefined ? (
                                <div className="heading3 semiBold padding16 padding24B">
                                  No driver Available
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          ) : (
                            <></>
                          )}
                          <div
                            style={{ margin: "7px 0 0px 96px", color: "red" }}
                          >
                            {errors.driverUserId && touched.driverUserId ? (
                              <div>*{errors.driverUserId}</div>
                            ) : null}
                          </div>
                        </div>
                      </FormGroup>
                    )}
                    {/* <FormGroup>
                      <label for="vrn" className="heading3 semiBold">
                        Driver:
                      </label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                      >
                        <input
                          className={`inputBoxCust1 form-control-1 ${
                            touched.amount && errors.amount ? "is-invalid" : ""
                          }`}
                          type="text"
                          id="driver"
                          name="driver"
                          touched={touched.driver}
                          errors={errors.driver}
                          onBlur={() => {
                            handleBlur("driver");
                            setOpen1(false);
                          }}
                          onClick={() => {
                            setOpen1(true);
                          }}
                          autoComplete="off"
                          onChange={(event) => {
                            console.log("kkjjsss", event.target.value);
                            setOpen1(true);
                            setSearchDriver(event.target.value);
                            setFieldValue("driver", event.target.value, true);
                          }}
                          value={values.driver}
                          onFocus={(e) => {
                            setOpen1(true);
                          }}
                          placeholder="Select Driver"
                          disabled={values?.isDummy == 1 ? true : false}
                        />
                        {console.log(
                          "values.drivervalues.driver",
                          values.driver
                        )}
                        <span
                          id="addDriver"
                          style={{ marginLeft: "20px", cursor: "pointer" }}
                          onClick={addDriver}
                          className={`inputBoxCust2`}
                        >
                          +
                        </span>
                      </div>
                      <div style={{ position: "relative" }}>
                        {open1 ? (
                          <div className="driverSearchContainer containerShadow">
                            <div
                              style={{
                                position: "absolute",
                                top: "0.3rem",
                                right: "0.3rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setOpen1(false);
                              }}
                            >
                              <SvgImage name="CloseButtonLogo" />
                            </div>
                            {driverList?.map((item, i) => {
                              return (
                                <>
                                  {item?.Fastag !== null ? (
                                    <div
                                      key={i}
                                      className="flexStyling padding8 "
                                      onMouseDown={(e) => e.preventDefault()}
                                      onClick={(event) => {
                                        setFieldValue(
                                          "driver",
                                          item?.User?.fullName,
                                          true
                                        );
                                        setFieldValue(
                                          "driverUserId",
                                          item?.User?.userId,
                                          true
                                        );
                                        console.log(
                                          "itemadas",
                                          item?.WalletAccount?.neoKred
                                            ?.accountStatus
                                        );
                                        setHasCard(
                                          item?.WalletAccount?.neoKred
                                            ?.accountStatus
                                        );
                                        setOpen1(false);
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="driver"
                                        value={item?.User?.userId}
                                        id={item?.User?.userId}
                                      />
                                      <div className="padding16L">
                                        {item?.User?.fullName.length > 35
                                          ? item?.User?.fullName.split(0, 35) +
                                            "..."
                                          : item?.User?.fullName}
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              );
                            })}
                            {driverCount == 0 ? (
                              <div className="heading3 semiBold padding16 padding24B">
                                No driver Available
                              </div>
                            ) : driverCount == undefined ? (
                              <div className="heading3 semiBold padding16 padding24B">
                                No driver Available
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                        <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                          {errors.driverUserId && touched.driverUserId ? (
                            <div>*{errors.driverUserId}</div>
                          ) : null}
                        </div>
                      </div>
                    </FormGroup> */}
                  </FormGroup>
                  <FormGroup
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <FormGroup>
                      <label for="from" className="heading3 semiBold">
                        From
                      </label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                      >
                        <input
                          type="text"
                          name="source"
                          id="source"
                          placeholder={"Source City"}
                          className={`inputBoxCust1 form-control-1 ${
                            touched.source && errors.source ? "is-invalid" : ""
                          }`}
                          aria-label="Default select example"
                          onChange={(e) => {
                            setDisplay1(true);
                            setSearch1(e.target.value);
                            setFieldValue("source", e.target.value, true);
                          }}
                          onClick={() => {
                            setDisplay1(true);
                          }}
                          value={values.source ? values.source : ""}
                          autoComplete="off"
                          errors={errors.source}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") {
                              // findSearch1();
                            }
                          }}
                          onBlur={(e) => {
                            setDisplay1(false);
                            if(!values.sourceId){
                              setFieldValue("source", "", true);
                            }
                          }}
                          onFocus={() => {
                            setDisplay1(true);
                          }}
                        ></input>
                        <span
                          style={{ marginLeft: "20px", cursor: "pointer" }}
                          onClick={addAddress}
                          className={`inputBoxCust2`}
                        >
                          +
                        </span>
                      </div>
                      {display1 ? (
                        <div
                          className="padding16 newCashback whiteBackground"
                          style={{
                            position: "absolute",
                            width: "350px",
                            height: "275px",
                            zIndex: "90",
                          }}
                        >
                          <div
                            onClick={() => {
                              setDisplay1(false);
                              setSearch1("");
                              //dispatch(clearAllDriversByVrn());
                              // setFieldValue("source", "", true);
                              // setFieldValue("sourceId", "", true);
                            }}
                            style={{
                              position: "absolute",
                              right: "0.5rem",
                              top: "0.5rem",
                              cursor: "pointer",
                            }}
                          >
                            <SvgImage name="CloseButtonLogo" />
                          </div>
                          <div
                            style={{
                              overflowY: "scroll",
                              overflowX: "hidden",
                              height: "240px",
                            }}
                          >
                            {console.log(
                              "savedAddresses11111",
                              search1,
                              savedAddresses
                            )}
                            {search1 == "" ? (
                              savedAddresses?.map((data, i) => {
                                let city = data?.cityName;
                                let state = data?.stateName;
                                let address = data?.address;
                                console.log(
                                  "savedAddresses",
                                  city,
                                  state,
                                  address,
                                  data
                                );
                                return (
                                  <div
                                    key={i}
                                    className="padding8 row"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => {
                                      // setcityId1(data?.cityName);
                                      setColor1(i);
                                      setDisplay1(false);
                                      //setUserId(data?.User?.userId);
                                      if (data?.addressId) {
                                        let newData = [...list];
                                        newData[0] = data;
                                        console.log("kmnirnjippjer",newData)
                                        distCalulation(newData)
                                        setList(newData);
                                      }
                                      setFieldValue(
                                        "sourceId",
                                        data?.addressId,
                                        true
                                      );
                                      setFieldValue(
                                        "source",
                                        `${address}, ${city} - ${state}`,
                                        true
                                      );
                                      setSourcePincode(data?.pincode);
                                      console.log(
                                        "kkjjjjj",
                                        destPincode,
                                        data?.pincode
                                      );
                                      if (destPincode && data?.pincode) {
                                        console.log("kkjjjjj");
                                        dispatch(
                                          getDistance(
                                            {
                                              source: data?.pincode,
                                              des: destPincode,
                                            },
                                            (res) => {
                                              if (res?.status == 200) {
                                                console.log(
                                                  "ppssspppppppp",
                                                  res?.data?.data?.distanceCal
                                                );
                                                // setDistanceCal(res?.data?.data?.distanceCal)
                                                setFieldValue(
                                                  "expectedDistanceKM",
                                                  parseFloat(
                                                    res?.data?.data?.distanceCal
                                                  )?.toFixed(2),
                                                  true
                                                );
                                                if((authUser?.company?.customFeatures?.includes("averageTripSpeed"))){
                                                  let endDate = values.expectedStartTime  && values.expectedStartTime!=""
                                                    ? new Date(values.expectedStartTime)
                                                    : new Date();
                                                  let dur = parseFloat(
                                                                res?.data?.data?.distanceCal
                                                              )?.toFixed(2)/(parseInt(JSON.parse(authUser?.company?.customFeatures)?.filter(r=>typeof r == "string" && r?.includes("averageTripSpeed"))[0].split("averageTripSpeed-")[1])||0)
                                                  let newEndDate = dur
                                                    ? new Date(
                                                        endDate.setHours(
                                                          endDate.getHours() + dur
                                                        )
                                                      )
                                                    : "";
                                                    setFieldValue("endDate", newEndDate, true);
                                                }
                                              }
                                            }
                                          )
                                        );
                                      }
                                    }}
                                  >
                                    {color1 === i ? (
                                      <div className="col-1">
                                        <SvgImage name="SelectedRadio" />
                                      </div>
                                    ) : (
                                      <div className="col-1">
                                        <SvgImage name="UnselectedRadio" />
                                      </div>
                                    )}
                                    {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                    <div
                                      className="col-11"
                                      style={{ textAlign: "left" }}
                                    >
                                      {address}, {city} - {state}
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <>
                                {savedAddresses?.map((data, i) => {
                                  let city = data?.cityName;
                                  let state = data?.stateName;
                                  let address = data?.address;

                                  console.log("check status", city, state);
                                  // let cardStatus=Number(data?.WalletAccount?.accountStatus);
                                  return (
                                    <div
                                      key={i}
                                      className="padding8 row"
                                      onMouseDown={(e) => e.preventDefault()}
                                      onClick={() => {
                                        // setcityId1(data?.cityName);
                                        setColor1(i);
                                        setDisplay1(false);
                                        //setUserId(data?.User?.userId);
                                        if (data?.addressId) {
                                          let newData = [...list];
                                          newData[0] = data;
                                          distCalulation(newData)
                                          setList(newData);
                                        }
                                        setFieldValue(
                                          "sourceId",
                                          data?.addressId,
                                          true
                                        );
                                        setFieldValue(
                                          "source",
                                          `${address}, ${city} - ${state}`,
                                          true
                                        );
                                        setSourcePincode(data?.pincode);
                                        if (destPincode && data?.pincode) {
                                          dispatch(
                                            getDistance(
                                              {
                                                source: data?.pincode,
                                                des: destPincode,
                                              },
                                              (res) => {
                                                if (res?.status == 200) {
                                                  console.log(
                                                    "ppssspppppppp",
                                                    res?.data?.data?.distanceCal
                                                  );
                                                  // setDistanceCal(res?.data?.data?.distanceCal)
                                                  setFieldValue(
                                                    "expectedDistanceKM",
                                                    parseFloat(
                                                      res?.data?.data
                                                        ?.distanceCal
                                                    )?.toFixed(2),
                                                    true
                                                  );
                                                  if((authUser?.company?.customFeatures?.includes("averageTripSpeed"))){
                                                    let endDate = values.expectedStartTime  && values.expectedStartTime!=""
                                                      ? new Date(values.expectedStartTime)
                                                      : new Date();
                                                    let dur = parseFloat(
                                                                  res?.data?.data?.distanceCal
                                                                )?.toFixed(2)/(parseInt(JSON.parse(authUser?.company?.customFeatures)?.filter(r=>typeof r == "string" && r?.includes("averageTripSpeed"))[0].split("averageTripSpeed-")[1])||0)
                                                    let newEndDate = dur
                                                      ? new Date(
                                                          endDate.setHours(
                                                            endDate.getHours() + dur
                                                          )
                                                        )
                                                      : "";
                                                    setFieldValue("endDate", newEndDate, true);
                                                  }
                                                }
                                              }
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {color1 === i ? (
                                        <div className="col-1">
                                          <SvgImage name="SelectedRadio" />
                                        </div>
                                      ) : (
                                        <div className="col-1">
                                          <SvgImage name="UnselectedRadio" />
                                        </div>
                                      )}
                                      <div
                                        className="col-11"
                                        style={{ textAlign: "left" }}
                                      >
                                        {address}, {city} - {state}
                                      </div>
                                    </div>
                                  );
                                })}
                              </>
                            )}
                            {savedAddresses?.length == 0 ? (
                              <div className="">
                                <div style={{ margin: "24px" }}>
                                  You have no addresses to select please add a
                                  new one
                                </div>
                                <div className="d-flex justify-content-center">
                                  <div
                                    className="greenButton d-flex justify-content-center align-items-center"
                                    style={{
                                      width: "200px",
                                      cursor: "pointer",
                                    }}
                                    onClick={addAddress}
                                  >
                                    <div>Add New Address</div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                        {errors.source && touched.source ? (
                          <div>*{errors.source}</div>
                        ) : null}
                      </div>
                    </FormGroup>

                    <FormGroup style={{}}>
                      <label for="to" className="heading3 semiBold">
                        To
                      </label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <input
                          type="text"
                          name="destination"
                          id="destination"
                          placeholder={"Destination City"}
                          className={`inputBoxCust1 form-control-1 ${
                            touched.destination && errors.destination
                              ? "is-invalid"
                              : ""
                          }`}
                          aria-label="Default select example"
                          onChange={(e) => {
                            setDisplay2(true);
                            setSearch2(e.target.value);
                            setFieldValue("destination", e.target.value, true);
                          }}
                          onClick={() => {
                            setDisplay2(true);
                          }}
                          value={values.destination || ""}
                          autoComplete="off"
                          errors={errors.destination}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") {
                              // findSearch2();
                            }
                          }}
                          onBlur={(e) => {
                            setDisplay2(false);
                          }}
                          onFocus={() => {
                            setDisplay2(true);
                          }}
                        ></input>
                        <span
                          style={{ marginLeft: "20px", cursor: "pointer" }}
                          onClick={addAddress}
                          className={`inputBoxCust2`}
                        >
                          +
                        </span>
                      </div>
                      {display2 ? (
                        <div
                          className="padding16 newCashback whiteBackground"
                          style={{
                            position: "absolute",
                            width: "350px",
                            height: "275px",
                            zIndex: "90",
                          }}
                        >
                          <div
                            onClick={() => {
                              setDisplay2(false);
                              setSearch2("");
                              //dispatch(clearAllDriversByVrn());
                              // setFieldValue("destination", "", true);
                            }}
                            style={{
                              position: "absolute",
                              right: "0.5rem",
                              top: "0.5rem",
                              cursor: "pointer",
                            }}
                          >
                            <SvgImage name="CloseButtonLogo" />
                          </div>
                          <div
                            style={{
                              overflowY: "scroll",
                              overflowX: "hidden",
                              height: "240px",
                            }}
                          >
                            {search2 == "" ? (
                              savedAddresses?.map((data, i) => {
                                let city = data?.cityName;
                                let state = data?.stateName;
                                let address = data?.address;
                                return (
                                  <div
                                    key={i}
                                    className="padding8 row"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => {
                                      // setcityId2(data?.cityName);
                                      setColor2(i);
                                      setDisplay2(false);
                                      //setUserId(data?.User?.userId);
                                      setFieldValue(
                                        "destination",
                                        `${address}, ${city} - ${state}`,
                                        true
                                      );
                                      if (
                                        list?.length == 0 ||
                                        list?.length == 1
                                      ) {
                                        let newData = [...list];
                                        if (list?.length == 0) {
                                          newData[0] = {};
                                        }
                                        newData[1] = data;
                                        setList(newData);
                                        distCalulation(newData)
                                      }
                                      if (list?.length > 1 && data?.addressId) {
                                        let newData = [...list];
                                        newData[list?.length - 1] = data;
                                        distCalulation(newData)
                                        setList(newData);
                                      }
                                      setFieldValue(
                                        "destId",
                                        data?.addressId,
                                        true
                                      );
                                      console.log(
                                        "llllllllkkk",
                                        sourcePincode,
                                        data?.pincode
                                      );
                                      setDestPincode(data?.pincode);
                                      if (sourcePincode && data?.pincode) {
                                        dispatch(
                                          getDistance(
                                            {
                                              source: sourcePincode,
                                              des: data?.pincode,
                                            },
                                            (res) => {
                                              if (res?.status == 200) {
                                                console.log(
                                                  "ppssspppppppp",
                                                  res?.data?.data?.distanceCal
                                                );
                                                setFieldValue(
                                                  "expectedDistanceKM",
                                                  parseFloat(
                                                    res?.data?.data?.distanceCal
                                                  )?.toFixed(2),
                                                  true
                                                );
                                                if((authUser?.company?.customFeatures?.includes("averageTripSpeed"))){
                                                  let endDate = values.expectedStartTime && values.expectedStartTime!=""
                                                    ? new Date(values.expectedStartTime)
                                                    : new Date();
                                                    console.log("endDateendDate",endDate);
                                                  let dur = parseFloat(
                                                                res?.data?.data?.distanceCal
                                                              )?.toFixed(2)/(parseInt(JSON.parse(authUser?.company?.customFeatures)?.filter(r=>typeof r == "string" && r?.includes("averageTripSpeed"))[0].split("averageTripSpeed-")[1])||0)
                                                  let newEndDate = dur
                                                    ? new Date(
                                                        endDate.setHours(
                                                          endDate.getHours() + dur
                                                        )
                                                      )
                                                    : "";
                                                  setFieldValue("endDate", newEndDate, true);
                                                }
                                              }
                                            }
                                          )
                                        );
                                      }
                                    }}
                                  >
                                    {color2 === i ? (
                                      <div className="col-1">
                                        <SvgImage name="SelectedRadio" />
                                      </div>
                                    ) : (
                                      <div className="col-1">
                                        <SvgImage name="UnselectedRadio" />
                                      </div>
                                    )}
                                    {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                    <div
                                      className="col-11"
                                      style={{ textAlign: "left" }}
                                    >
                                      {address}, {city} - {state}
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <>
                                {savedAddresses?.map((data, i) => {
                                  let city = data?.cityName;
                                  let state = data?.stateName;
                                  let address = data?.address;

                                  console.log("check status", city, state);
                                  // let cardStatus=Number(data?.WalletAccount?.accountStatus);
                                  return (
                                    <div
                                      key={i}
                                      className="padding8 row"
                                      onMouseDown={(e) => e.preventDefault()}
                                      onClick={() => {
                                        // setcityId2(data?.cityName);
                                        setColor2(i);
                                        setDisplay2(false);
                                        //setUserId(data?.User?.userId);
                                        setFieldValue(
                                          "destination",
                                          `${address}, ${city} - ${state}`,
                                          true
                                        );
                                        if (
                                          list?.length == 0 ||
                                          list?.length == 1
                                        ) {
                                          let newData = [...list];
                                          if (list?.length == 0) {
                                            newData[0] = {};
                                          }
                                          newData[1] = data;
                                          distCalulation(newData)
                                          setList(newData);
                                        }
                                        if (
                                          list?.length > 1 &&
                                          data?.addressId
                                        ) {
                                          let newData = [...list];
                                          newData[list?.length - 1] = data;
                                          distCalulation(newData)
                                          setList(newData);
                                        }
                                        setFieldValue(
                                          "destId",
                                          data?.addressId,
                                          true
                                        );
                                        setDestPincode(data?.pincode);
                                        if (sourcePincode && data?.pincode) {
                                          dispatch(
                                            getDistance(
                                              {
                                                source: sourcePincode,
                                                des: data?.pincode,
                                              },
                                              (res) => {
                                                if (res?.status == 200) {
                                                  console.log(
                                                    "ppssspppppppp",
                                                    res?.data?.data?.distanceCal
                                                  );
                                                  setFieldValue(
                                                    "expectedDistanceKM",
                                                    parseFloat(
                                                      res?.data?.data
                                                        ?.distanceCal
                                                    )?.toFixed(2),
                                                    true
                                                  );
                                                  if((authUser?.company?.customFeatures?.includes("averageTripSpeed"))){
                                                    let endDate = values.expectedStartTime  && values.expectedStartTime!=""
                                                      ? new Date(values.expectedStartTime)
                                                      : new Date();
                                                    let dur = parseFloat(
                                                                  res?.data?.data?.distanceCal
                                                                )?.toFixed(2)/(parseInt(JSON.parse(authUser?.company?.customFeatures)?.filter(r=>typeof r == "string" && r?.includes("averageTripSpeed"))[0].split("averageTripSpeed-")[1])||0)
                                                    let newEndDate = dur
                                                      ? new Date(
                                                          endDate.setHours(
                                                            endDate.getHours() + dur
                                                          )
                                                        )
                                                      : "";
                                                    setFieldValue("endDate", newEndDate, true);
                                                  }
                                                }
                                              }
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      {color2 === i ? (
                                        <div className="col-1">
                                          <SvgImage name="SelectedRadio" />
                                        </div>
                                      ) : (
                                        <div className="col-1">
                                          <SvgImage name="UnselectedRadio" />
                                        </div>
                                      )}
                                      <div
                                        className="col-11"
                                        style={{ textAlign: "left" }}
                                      >
                                        {address}, {city} - {state}
                                      </div>
                                    </div>
                                  );
                                })}
                              </>
                            )}
                            {savedAddresses?.length == 0 ? (
                              <div className="">
                                <div style={{ margin: "24px" }}>
                                  You have no addresses to select please add a
                                  new one
                                </div>
                                <div className="d-flex justify-content-center">
                                  <div
                                    className="greenButton d-flex justify-content-center align-items-center"
                                    style={{
                                      width: "200px",
                                      cursor: "pointer",
                                    }}
                                    onClick={addAddress}
                                  >
                                    <div>Add New Address</div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                        {errors.destination && touched.destination ? (
                          <div>*{errors.destination}</div>
                        ) : null}
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <div
                        className="heading3 semiBold"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setShowStops(!showStops);
                        }}
                      >
                        Show Stops
                      </div>
                      <div>
                        {showStops ? (
                          <div
                            className="padding16 newCashback whiteBackground"
                            style={{
                              position: "absolute",
                              width: "350px",
                              height: "360px",
                              zIndex: "90",
                            }}
                          >
                            <div
                              onClick={() => {
                                setShowStops(false);
                              }}
                              style={{
                                textAlign: "right",
                                cursor: "pointer",
                                zIndex: 10,
                              }}
                            >
                              <SvgImage name="CloseButtonLogo" />
                            </div>
                            <div
                              style={{
                                overflowY: "scroll",
                                overflowX: "hidden",
                                height: "300px",
                                // backgroundColor: "red",
                              }}
                            >
                              <DragDropContext onDragEnd={handleDragEnd}>
                                <Droppable droppableId="droppable">
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.droppableProps}
                                    >
                                      {list?.map((data, i) => {
                                        let city = data?.cityName;
                                        let state = data?.stateName;
                                        let address = data?.address;
                                        return (
                                          <Draggable
                                            key={data.addressId}
                                            index={i}
                                            draggableId={data.addressId}
                                          >
                                            {(provided, snapshot) => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                key={i}
                                                className="padding8 d-flex"
                                                onMouseDown={(e) =>
                                                  e.preventDefault()
                                                }
                                                style={{
                                                  ...provided.draggableProps
                                                    .style,
                                                  // customized drag style
                                                  background:
                                                    snapshot.isDragging
                                                      ? "lightblue"
                                                      : "transparent",
                                                  padding: "8px 16px",
                                                  // background: "lightblue",
                                                  borderRadius: "16px",
                                                  alignItems: "center",
                                                }}
                                                onClick={() => {}}
                                              >
                                                <div
                                                  className=""
                                                  style={{
                                                    alignContent: "center",
                                                  }}
                                                >
                                                  <SvgImage name="drag" />
                                                </div>
                                                <div
                                                  className=""
                                                  style={{
                                                    textAlign: "left",
                                                    paddingLeft: 12,
                                                  }}
                                                >
                                                  {address}, {city} - {state}
                                                </div>
                                                <div
                                                  style={{
                                                    fontSize: "35px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    let newData = [...list];
                                                    newData?.splice(i, 1);
                                                    
                                                    distCalulation(newData)
                                                    setList(newData);
                                                  }}
                                                >
                                                  -
                                                </div>
                                              </div>
                                            )}
                                          </Draggable>
                                        );
                                      })}
                                      {addStop ? (
                                        <div>
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "flex-start",
                                              padding: "8px 16px",
                                            }}
                                          >
                                            <div
                                              className=""
                                              style={{
                                                alignContent: "center",
                                              }}
                                            >
                                              <SvgImage name="drag" />
                                            </div>
                                            <input
                                              type="text"
                                              placeholder={"Add new Stop"}
                                              className={`form-control-1`}
                                              style={{ marginLeft: 12 }}
                                              aria-label="Default select example"
                                              onChange={(e) => {
                                                setDisplay3(true);
                                                console.log(
                                                  "e.target.value",
                                                  e.target.value
                                                );
                                                if (e.target.value) {
                                                  setSearch3(e.target.value);
                                                  setFieldValue("newAdderss", e.target.value, true);
                                                } else {
                                                  setSearch3("");
                                                  setFieldValue("newAdderss", '', true);
                                                }
                                              }}
                                              onClick={() => {
                                                setDisplay3(true);
                                              }}
                                              value={values.newAdderss}
                                              autoComplete="off"
                                              onKeyUp={(e) => {
                                                if (e.key === "Enter") {
                                                  // findSearch2();
                                                }
                                              }}
                                              onBlur={(e) => {
                                                setDisplay3(false);
                                              }}
                                              onFocus={() => {
                                                setDisplay3(true);
                                              }}
                                            ></input>
                                          </div>
                                          {display3 ? (
                                            <div
                                              className="padding16 newCashback whiteBackground"
                                              style={{
                                                // position: "absolute",
                                                width: "300px",
                                                height: "275px",
                                                zIndex: "90",
                                              }}
                                            >
                                              {/* <div
                                                onClick={() => {
                                                  setDisplay3(false);
                                                  setSearch3("");
                                                  //dispatch(clearAllDriversByVrn());
                                                  // setFieldValue("destination", "", true);
                                                }}
                                                style={{
                                                  position: "absolute",
                                                  right: "0.5rem",
                                                  top: "0.5rem",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <SvgImage name="CloseButtonLogo" />
                                              </div> */}
                                              <div
                                                style={{
                                                  overflowY: "scroll",
                                                  overflowX: "hidden",
                                                  height: "240px",
                                                }}
                                              >
                                                {search3 == "" ? (
                                                  savedAddresses?.map(
                                                    (data, i) => {
                                                      let city = data?.cityName;
                                                      let state =
                                                        data?.stateName;
                                                      let address =
                                                        data?.address;
                                                      return (
                                                        <div
                                                          key={i}
                                                          className="padding8 row"
                                                          onMouseDown={(e) =>
                                                            e.preventDefault()
                                                          }
                                                          onClick={() => {
                                                            // setcityId2(data?.cityName);
                                                            setColor2(i);
                                                            setDisplay3(false);
                                                            setSearch3("");

                                                            setNewStop(data);
                                                          }}
                                                        >
                                                          {color2 === i ? (
                                                            <div className="col-1">
                                                              <SvgImage name="SelectedRadio" />
                                                            </div>
                                                          ) : (
                                                            <div className="col-1">
                                                              <SvgImage name="UnselectedRadio" />
                                                            </div>
                                                          )}
                                                          {/* <div className="col-1">
                      <SvgImage name="UnselectedRadio" />
                    </div> */}
                                                          <div
                                                            className="col-11"
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            {address}, {city} -{" "}
                                                            {state}
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                ) : (
                                                  <>
                                                    {savedAddresses?.map(
                                                      (data, i) => {
                                                        let city =
                                                          data?.cityName;
                                                        let state =
                                                          data?.stateName;
                                                        let address =
                                                          data?.address;

                                                        console.log(
                                                          "check status",
                                                          city,
                                                          state
                                                        );
                                                        // let cardStatus=Number(data?.WalletAccount?.accountStatus);
                                                        return (
                                                          <div
                                                            key={i}
                                                            className="padding8 row"
                                                            onMouseDown={(e) =>
                                                              e.preventDefault()
                                                            }
                                                            onClick={() => {
                                                              // setcityId2(data?.cityName);
                                                              setColor2(i);
                                                              setDisplay3(
                                                                false
                                                              );
                                                              //setUserId(data?.User?.userId);
                                                              setSearch3("");
                                                              setNewStop(data);
                                                            }}
                                                          >
                                                            {color2 === i ? (
                                                              <div className="col-1">
                                                                <SvgImage name="SelectedRadio" />
                                                              </div>
                                                            ) : (
                                                              <div className="col-1">
                                                                <SvgImage name="UnselectedRadio" />
                                                              </div>
                                                            )}
                                                            <div
                                                              className="col-11"
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              {address}, {city}{" "}
                                                              - {state}
                                                            </div>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </>
                                                )}
                                                {savedAddresses?.length == 0 ? (
                                                  <div className="">
                                                    <div
                                                      style={{ margin: "24px" }}
                                                    >
                                                      You have no addresses to
                                                      select please add a new
                                                      one
                                                    </div>
                                                    <div className="d-flex justify-content-center">
                                                      <div
                                                        className="greenButton d-flex justify-content-center align-items-center"
                                                        style={{
                                                          width: "200px",
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={addAddress}
                                                      >
                                                        <div>
                                                          Add New Address
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </div>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      ) : null}

                                      <div
                                        className="heading3 semiBold"
                                        style={{
                                          textAlign: "right",
                                          cursor: "pointer",
                                          marginTop: "12px",

                                          // zIndex: 10,
                                        }}
                                        onClick={() => {
                                          setAddStop(!addStop);
                                          if (addStop && newStop?.addressId) {
                                            let newData = [...list];
                                            newData.push(newStop);
                                            console.log("nbjhweiohiterh",newData)
                                            distCalulation(newData)
                                            setList(newData);
                                            
                                          }
                                        }}
                                      >
                                        {addStop ? "Save" : "+ Add Stop"}
                                      </div>
                                    </div>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </FormGroup>
                  </FormGroup>
                  <FormGroup
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <FormGroup>
                      <label for="vrn" className="heading3 semiBold">
                        Start Date
                      </label>
                      <div
                        className="custNamepadd3 row"
                        style={{ width: "200px" }}
                      >
                        <div className="col-9">
                          <DatePickerField
                            classname="searchBar-input1"
                            name="startDate"
                            header="Select Start date"
                            value={values.startDate}
                            onChange={(v) => {
                              let endDate = v ? new Date(v) : new Date();
                              let newEndDate = routeData?.durationCal
                                ? new Date(
                                    endDate.setHours(
                                      endDate.getHours() +
                                        parseFloat(routeData?.durationCal) / 60
                                    )
                                  )
                                : "";
                              setFieldValue("startDate", v, true);
                              setFieldValue("endDate", newEndDate, true);
                            }}
                            //onChange={(v) => setFieldValue("endDate", v, true)}
                            // minDate={
                            //   values.startDate === "" ? "" : values.startDate
                            // }
                            // maxDate={new Date()}
                            ref1={datepickerRefEnd}
                            style={{ width: "100px" }}
                            showTimeInput={true}
                          />
                        </div>
                        <div className="col-3">
                          <label
                            className="date-input"
                            for="startDate"
                            style={{
                              position: "relative",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickDatepickerIcon2();
                            }}
                          >
                            <SvgImage
                              name="CalenderLogo"
                              width="32"
                              height="32"
                            />
                          </label>
                        </div>
                      </div>
                      <div
                        className="heading4 Regular"
                        style={{ margin: "7px 0 0px 0", color: "red" }}
                      >
                        {errors.startDate && touched.startDate ? (
                          <div>*{errors.startDate}</div>
                        ) : null}
                      </div>
                    </FormGroup>
                    <FormGroup style={{}}>
                      <label for="vrn" className="heading3 semiBold">
                        End Date
                      </label>
                      <div
                        className="custNamepadd3 row"
                        style={{ width: "200px" }}
                      >
                        <div className="col-9">
                          <DatePickerField
                            classname="searchBar-input1"
                            name="endtDate"
                            header="Select End date"
                            value={values.endDate}
                            onChange={(v) => {
                              setFieldValue("endDate", v, true);
                            }}
                            minDate={
                              values.startDate === "" ? "" : values.startDate
                            }
                            ref1={datepickerRefStart}
                            style={{ width: "100px" }}
                            showTimeInput={true}
                          />
                        </div>
                        <div className="col-3">
                          <label
                            className="date-input"
                            for="endDate"
                            style={{
                              position: "relative",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickDatepickerIcon1();
                            }}
                          >
                            <SvgImage
                              name="CalenderLogo"
                              width="32"
                              height="32"
                            />
                          </label>
                        </div>
                      </div>
                      <div
                        className="heading4 Regular"
                        style={{ margin: "7px 0 0px 0", color: "red" }}
                      >
                        {errors.endDate && touched.endDate ? (
                          <div>*{errors.endDate}</div>
                        ) : null}
                      </div>
                    </FormGroup>
                  </FormGroup>
                  <FormGroup
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <FormGroup>
                      <label for="tripNo" className="heading3 semiBold">
                        Expected Distance(KMs):
                      </label>
                      <input
                        type="text"
                        id="expectedDistanceKM"
                        className={`inputBoxCust1 form-control-1 ${
                          touched.expectedDistanceKM &&
                          errors.expectedDistanceKM
                            ? "is-invalid"
                            : ""
                        }`}
                        name="expectedDistanceKM"
                        onChange={(event) => {
                          // setSearch(event.target.value);
                          setFieldValue(
                            "expectedDistanceKM",
                            event.target.value,
                            true
                          );
                        }}
                        value={values.expectedDistanceKM}
                        touched={touched.expectedDistanceKM}
                        errors={errors.expectedDistanceKM}
                        placeholder="Enter Expected Distance"
                      />
                    </FormGroup>
                    <FormGroup>
                        <label for="vrn" className="heading3 semiBold">
                          Branch:
                        </label>
                        <div
                          className="custNamepadd3"
                        >
                          <input
                            className={`inputBoxCust1 form-control-1 ${
                              touched.branch && errors.branch
                                ? "is-invalid"
                                : ""
                            }`}
                            type="text"
                            id="branch"
                            name="branch"
                            touched={touched.branch}
                            errors={errors.branch}
                            onBlur={() => {
                              handleBlur("branch");
                              setOpen2(false);
                            }}
                            onClick={() => {
                              setOpen2(true);
                            }}
                            autoComplete="off"
                            onChange={(event) => {
                              console.log("kkjjsss", event.target.value);
                              setOpen2(true);
                              setSearchBranch(event.target.value);
                              setFieldValue("branchName", event.target.value, true);
                            }}
                            value={values.branchName}
                            onFocus={(e) => {
                              setOpen2(true);
                            }}
                            placeholder="Select Branch"
                            disabled={
                              values?.isDummy == 2 || values?.isDummy == "0"
                                ? true
                                : false
                            }
                          />
                          {console.log(
                            "values.branch.branch",
                            values.branchId
                          )}
                        </div>
                        <div style={{ position: "relative" }}>
                          {open2 ? (
                            <div className="driverSearchContainer containerShadow">
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0.3rem",
                                  right: "0.3rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setOpen2(false);
                                }}
                              >
                                <SvgImage name="CloseButtonLogo" />
                              </div>
                              {console.log("branchList",branchList)}
                              {branchList?.map((item, i) => {
                                return (
                                  <>
                                  {console.log("itemitem",item)}
                                    {item?.Fastag !== null ? (
                                      <div
                                        key={i}
                                        className="flexStyling padding8 "
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={(event) => {
                                          // setBranchName(item?.branchName)
                                          setFieldValue(
                                            "branchName",
                                            item?.branchName,
                                            true
                                          );
                                          setFieldValue(
                                            "branchId",
                                            item?.branchId,
                                            true
                                          );
                                          setOpen2(false);
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="driver"
                                          value={item?.branchId}
                                          id={item?.branchId}
                                        />
                                        <div className="padding16L">
                                          {item?.branchName}
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                );
                              })}
                              {branchCount == 0 ? (
                                <div className="heading3 semiBold padding16 padding24B">
                                  No Branch Available
                                </div>
                              ) : driverCount == undefined ? (
                                <div className="heading3 semiBold padding16 padding24B">
                                  No Branch Available
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          ) : (
                            <></>
                          )}
                          <div
                            style={{ margin: "0px 0 0px 96px", color: "red" }}
                          >
                            {errors.driverUserId && touched.driverUserId ? (
                              <div>*{errors.driverUserId}</div>
                            ) : null}
                          </div>
                        </div>
                      </FormGroup>
                    {values?.isDummy == 1 || values?.isDummy == 3 ? (
                      <FormGroup>
                        <label for="vrn" className="heading3 semiBold">
                          {values?.isDummy == 3
                            ? "Monthly Vendor :"
                            : "Vendor :"}
                        </label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <input
                            className={`inputBoxCust1 form-control-1 ${
                              touched.vendor && errors.vendor
                                ? "is-invalid"
                                : ""
                            }`}
                            type="text"
                            id="vendor"
                            name="vendor"
                            touched={touched.vendor}
                            errors={errors.vendor}
                            // onBlur={() => {
                            //   handleBlur("vendorId");
                            //   setSelectVendorModal(false);
                            // }}
                            onClick={() => {
                              setSelectVendorModal(true);
                            }}
                            disabled={
                              values?.isDummy == "2" || values?.isDummy == "3"
                                ? true
                                : false
                            }
                            autoComplete="off"
                            onChange={(event) => {
                              console.log("kkjjsss", event.target.value);
                              if (event.target.value == "") {
                                setVendorDetails("")
                                setFieldValue("vendor", "", false);
                                // setFieldValue("isDummy", "", true);
                                setVendorId("")
                                setFieldValue("vendorId", "", false);
                                setVendorCheck("");
                              } else setSelectVendorModal(true);
                            }}
                            value={values.vendor}
                            // onFocus={(e) => {
                            //   setSelectVendorModal(true);
                            // }}
                            placeholder="Select Vendor"
                          />
                          {values?.isDummy == "2" || values?.isDummy == "3" ? (
                            <></>
                          ) : (
                            <span
                              style={{ marginLeft: "20px", cursor: "pointer" }}
                              onClick={addVendor}
                              className={`inputBoxCust2`}
                            >
                              +
                            </span>
                          )}
                        </div>
                        <div style={{ position: "relative" }}>
                          <div
                            style={{ margin: "7px 0 0px 96px", color: "red" }}
                          >
                            {errors.vendor && touched.vendor ? (
                              <div>*{errors.vendor}</div>
                            ) : null}
                          </div>
                        </div>
                      </FormGroup>
                    ) : (
                      <></>
                    )}
                  </FormGroup>
                  <FormGroup
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "25px",
                      marginTop: "30px",
                    }}
                  >
                    <Button
                      type="submit"
                      style={{ width: "25%" }}
                      className="generateOtp text3 Medium btn btn-secondary"
                      disabled={loader}
                    >
                      {loader ? (
                        <>
                          <ClipLoader
                            // color={"#fff"}
                            loading={true}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </>
                      ) : (
                        "Create Trip"
                      )}
                    </Button>
                  </FormGroup>
                  {selectVendorModal && (
                    <SelectVendorModal
                      open={selectVendorModal}
                      onHide={() => {
                        setSelectVendorModal(false);
                      }}
                      toggleModal={() => {
                        setSelectVendorModal(!selectVendorModal);
                      }}
                      handleClose={() => {
                        setSelectVendorModal(false);
                      }}
                      onClickItem={(data) => {
                        // setVendorData({});
                        // setVendorData(data);
                        if (values?.fleetId) {
                          setConfirm(true);
                        }
                        console.log("dadatata", data);
                        setVendorDetails(data?.name)
                        setFieldValue("vendor", data?.name, false);
                        // setFieldValue("isDummy", 1, true);
                        setVendorId(data?.id)
                        setFieldValue("vendorId", data?.id, false);
                        setVendorCheck(data?.id);
                        setSelectVendorModal(false);
                      }}
                      search={searchVendor}
                      setSearch={setSearchVendor}
                      vendorType={"2"}
                    />
                  )}
                  {confirm ? (
                    <ConfirmationModal
                      isOpen={confirm}
                      onHide={onHide}
                      toggleModal={() => {
                        setConfirm(!confirm);
                      }}
                      handleClose={() => {
                        setConfirm(false);
                      }}
                      onPress={() => {
                        setConfirm(false);
                        let toggleModalToast = () => {
                          dispatch(
                            toastStatus({
                              toastStatus: false,
                            })
                          );
                        };
                        let handleCloseToast = () => {
                          dispatch(
                            toastStatus({
                              toastStatus: false,
                            })
                          );
                        };
                        dispatch(
                          addFleet(
                            {
                              vehicleNumber: values?.vrn,
                              vendorId: values?.vendorId,
                              isRegular: 2,
                            },
                            (response) => {
                              console.log(
                                "resppppppp8888ppp",
                                response,
                                response?.type,
                                response?.type == "success",
                                response?.type === "success"
                              );
                              if (
                                response?.type === "success" &&
                                response?.data
                              ) {
                                setFieldValue("isDummy", "2", true);
                                //window.location.reload();
                              } else {
                                //alert(response);
                              }
                            },
                            toggleModalToast,
                            handleCloseToast
                          )
                        );
                      }}
                      msg={`Do You want to add this vehicle on ${values.vendor} Permanently`}
                    />
                  ) : (
                    <></>
                  )}
                  {vendor ? (
                    <AddVendor
                      toggle={addVendor}
                      freight={vendor}
                      onSuccess={(e) => {
                        setVendorDetails(e?.name)
                        setFieldValue("vendor", e?.name, false);
                        // setFieldValue("isDummy", 1, true);
                        setVendorId(e?.id)
                        setFieldValue("vendorId", e?.id, false);
                      }}
                      confirm={confirm}
                      setConfirm={setConfirm}
                    />
                  ) : (
                    <></>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>

      {/* <Toast
        success={openToast}
        message={"Trip Has Been created Successfully"}
        isOpen={openToast}
        name="trips"
        handleClose={() => {
          handleClose(false);
          // setTripData({});
          setPaymentDetailsModal(true);
          setSelectedRow([]);
          setOpenToast(false);
          dispatch(
            getLRList({
              offset: 0,
              limit: 10,
            })
          );
        }}
      /> */}
      <AddDriverV2 toggle={addDriver} freight={driver} />
      <AddVehicleV2 toggle={addVehicle} freight={vehicle} />
      {/* <Toast
        success={false}
        message={openToastFailureText}
        isOpen={openToastFailure}
        name="trips"
        handleClose={() => {
          setOpenToast(false);
          handleClose(false);
        }}
      /> */}
      <AddAddress
        toggle={addAddress}
        address={addressModal}
        setAddress={setAddressModal}
      />
    </div>
  );
}

export default CreateTripFromLR;
